module.exports = __webpack_public_path__ + "word_logo.svg?0e53aca3cd635b3378bf31e455ca23c5";


//////////////////
// WEBPACK FOOTER
// ./client/src/assets/images/word_logo.svg
// module id = 464
// module chunks = 0